import dayjs from "dayjs";
import { Transaction } from "./types";

/**
 * Проверка фильтров, которых нет на сокете.
 *
 * Сервер отсеивает только точные совпадения (мерчант, терминал, статус, метод,
 * тип, валюта). Диапазоны дат и сумм он не поддерживает — событие приходит, а
 * решение показывать строку принимает клиент. Условия повторяют get_list_test:
 * суммы сравниваются с start_amount, даты — с created_at и updated_at.
 */
export type ClientFilters = {
  createdFrom?: unknown;
  createdTo?: unknown;
  updatedFrom?: unknown;
  updatedTo?: unknown;
  minsum?: number | null;
  maxsum?: number | null;
};

const startOfDay = (value: unknown) => {
  if (!value) return null;
  const parsed = dayjs(value as any);
  return parsed.isValid() ? parsed.startOf("day") : null;
};

const endOfDay = (value: unknown) => {
  if (!value) return null;
  const parsed = dayjs(value as any);
  return parsed.isValid() ? parsed.endOf("day") : null;
};

export const matchesClientFilters = (
  transaction: Partial<Transaction>,
  filters: ClientFilters,
): boolean => {
  const amount = transaction.start_amount;
  if (typeof amount === "number") {
    if (filters.minsum && amount < filters.minsum) return false;
    if (filters.maxsum && amount > filters.maxsum) return false;
  }

  const created = transaction.created_at ? dayjs(transaction.created_at) : null;
  if (created?.isValid()) {
    const from = startOfDay(filters.createdFrom);
    const to = endOfDay(filters.createdTo);
    if (from && created.isBefore(from)) return false;
    if (to && created.isAfter(to)) return false;
  }

  const updated = transaction.updated_at ? dayjs(transaction.updated_at) : null;
  if (updated?.isValid()) {
    const from = startOfDay(filters.updatedFrom);
    const to = endOfDay(filters.updatedTo);
    if (from && updated.isBefore(from)) return false;
    if (to && updated.isAfter(to)) return false;
  }

  return true;
};
